import { Component, HostBinding, Input } from '@angular/core';
import { MaterialImportsModule } from 'src/app/material-imports.module';

/**
 * Thumbnail that supports optimized image loading
 * and shows a bigger preview on hover
 */
@Component({
  selector: 'app-thumbnail[src]',
  imports: [
    MaterialImportsModule
  ],
  templateUrl: './thumbnail.component.html',
  styleUrls: ['./thumbnail.component.scss']
})
export class ThumbnailComponent {
  @Input({ required: true })
  public src!: string;

  @Input()
  public fullSizeSrc?: string;

  @Input()
  public alt?: string;

  @Input()
  public thumbnailWidth = 50;

  @Input()
  public thumbnailHeight = 50;

  @Input()
  public previewHeight = 200;

  @Input()
  public previewWidth = 200;

  @HostBinding('style.width')
  private get width() {
    return `${this.thumbnailWidth}px`;
  }

  @HostBinding('style.height')
  private get height() {
    return `${this.thumbnailHeight}px`;
  }
}
